// extracted by mini-css-extract-plugin
module.exports = {"custom":"styles_custom__sp_2W","customButton":"styles_customButton__lG7sB"};